import { useCallback } from 'react';
import classNames from 'classnames';
import { Button } from '@canvas-logic/clp-shared-ui';
import { WebArControl } from '@/ui-kit/components/WebArControl/WebArControl';
import ThemeDefinition from '@/ui-kit/domain/ThemeDefinition';
import ShareButton from '@/ui-kit/components/ShareButton/ShareButton';
import PdfDownloadButton from '@/ui-kit/components/PdfDownloadButton/PdfDownloadButton';
import { HighQualityRenderModal } from '@/ui-kit/components/HighQualityRenderModal';
import { ModalName, modalStore } from '@/ui-kit/components/Modal/ModalStore';
import { Bootstrapper } from '@/ui-kit/domain/Bootstrapper';
import { observer } from 'mobx-react';
import { useSheetRouter } from '@/ui-kit/components/SheetRouter/SheetRouterContext';
import { useMediaQuery } from '@/ui-kit/hooks/use-media-query';

interface IProps {
  className?: string;
  bootstrapper: Bootstrapper;
  hasAr?: boolean;
  hasInfo?: boolean;
  hasShare?: boolean;
}

const Actions = ({ className, bootstrapper, hasAr, hasInfo = false, hasShare = false }: IProps) => {
  const { openActions } = useSheetRouter();
  const isEnoughSpace = useMediaQuery('only screen and (min-width: 425px)');
  const actionsCount = Number(hasInfo) + Number(Boolean(hasAr)) + Number(hasShare) + Number(bootstrapper.isInCatalog);
  const hasMoreThanTwoActions = actionsCount > 2;

  // Use computed hqrImageUrl - only show button if there's an image for current config
  const hqrAvailable = !!bootstrapper.hqrImageUrl;

  const handleOpenHighQualityRender = useCallback(() => {
    modalStore.openModal(ModalName.HIGH_QUALITY_RENDER);
  }, []);

  if (!isEnoughSpace && hasMoreThanTwoActions) {
    return (
      <>
        <div className={classNames('viewport__actions', className)}>
          <Button variant="ternary" iconStart="more" onClick={() => openActions()} />
        </div>
        {hqrAvailable && <HighQualityRenderModal bootstrapper={bootstrapper} />}
      </>
    );
  }

  return (
    <>
      <div className={classNames('viewport__actions', className)}>
        {hasInfo && (
          <Button
            variant={bootstrapper.showRuler ? 'primary' : 'ternary'}
            iconStart="info"
            onClick={() => bootstrapper.switchRuler()}
          />
        )}
        {hasAr && <WebArControl className={ThemeDefinition.layout.arButton} api={bootstrapper.api} />}
        {hasShare && <ShareButton />}
        {bootstrapper.isInCatalog ? <PdfDownloadButton /> : null}
        {hqrAvailable && <Button variant="ternary" iconStart="camera" onClick={handleOpenHighQualityRender} />}
      </div>
      {hqrAvailable && <HighQualityRenderModal bootstrapper={bootstrapper} />}
    </>
  );
};

export default observer(Actions);
